module.exports = __webpack_public_path__ + "img/phone.75b68dd0.svg";